import { TemplateNodeSchema } from '@ulysses-inc/harami_api_client'
import { useSelector } from 'react-redux'
import { useLimitedFeatureAvailability } from 'src/features/featureAvailability/useLimitedFeatureAvailability'
import { isTraceableQuestionType } from 'src/features/templateEdit/questionOptions/domain/traceKey'
import { selectIsGridLayout } from 'src/state/ducks/templates/selectors'

/**
 * 検索キー(TraceKey)機能が使用可能かどうかを判定するReact Hook
 *
 * @param node - 判定対象のテンプレートノード
 * @returns 検索キー機能が使用可能な場合はtrue
 *
 * @remarks
 * 以下の条件をすべて満たす場合に使用可能と判定されます:
 * - 回答検索の利用条件を満たしている（契約プラン）
 * - 表形式ではない
 * - 質問種別が検索キーに対応している
 */
export const useCanTrace = (node: TemplateNodeSchema): boolean => {
  const { isFeatureAvailable } = useLimitedFeatureAvailability()
  const isGridLayout = useSelector(selectIsGridLayout)

  if (!isFeatureAvailable('reportTrace')) {
    return false
  }

  if (isGridLayout) {
    return false
  }

  return isTraceableQuestionType(node.question)
}
